const EVENT_LABEL = {
  created: "Created",
  activated: "Activated",
  paused: "Paused",
  resumed: "Resumed",
  canceled_immediate: "Canceled",
  canceled_at_period_end: "Cancel at period end",
  renewed: "Renewed",
  lapsed: "Lapsed",
  note_added: "Note added",
  price_adjusted: "Price adjusted",
  deleted: "Deleted",
};

const EVENT_TINT = {
  created: "bg-slate-100 text-slate-700 border-slate-300",
  activated: "bg-emerald-100 text-emerald-800 border-emerald-300",
  paused: "bg-amber-100 text-amber-900 border-amber-300",
  resumed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  canceled_immediate: "bg-red-50 text-red-800 border-red-200",
  canceled_at_period_end: "bg-rose-50 text-rose-800 border-rose-200",
  renewed: "bg-sky-100 text-sky-900 border-sky-300",
  lapsed: "bg-rose-100 text-rose-900 border-rose-300",
  note_added: "bg-slate-50 text-slate-600 border-slate-200",
  price_adjusted: "bg-violet-50 text-violet-800 border-violet-200",
  deleted: "bg-red-100 text-red-900 border-red-300",
};

function fmtCents(cents) {
  if (cents === null || cents === undefined) return "—";
  return `$${(cents / 100).toFixed(2)}`;
}

export default function SubscriptionEventTrail({ entries }) {
  if (!entries.length) {
    return (
      <div className="text-xs text-slate-500" data-testid="sub-event-empty">
        No events yet.
      </div>
    );
  }
  return (
    <ol data-testid="sub-event-trail" className="space-y-3">
      {entries.map((e) => (
        <li
          key={e.id}
          data-testid={`sub-event-${e.id}`}
          className="flex items-start gap-3"
        >
          <span
            className={`mt-0.5 inline-flex items-center rounded-md border px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide ${
              EVENT_TINT[e.event_type] ||
              "bg-slate-100 text-slate-700 border-slate-300"
            }`}
          >
            {EVENT_LABEL[e.event_type] || e.event_type}
          </span>
          <div className="flex-1 min-w-0">
            <div className="text-xs text-slate-700">
              <span className="font-semibold text-slate-900">
                {e.actor_name || "system"}
              </span>
              {e.from_status && e.to_status && e.from_status !== e.to_status && (
                <>
                  {" · "}
                  {e.from_status} → {e.to_status}
                </>
              )}
            </div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-0.5 font-data">
              {new Date(e.created_at).toLocaleString()}
            </div>
            {e.event_type === "price_adjusted" && (
              <div className="text-[11px] text-violet-800 mt-1">
                {fmtCents(e.metadata?.amount_cents_old)} →{" "}
                {fmtCents(e.metadata?.amount_cents_new)}
              </div>
            )}
            {e.event_type === "renewed" && e.metadata?.period_end && (
              <div className="text-[11px] text-slate-600 mt-1">
                New period: {e.metadata.period_start} → {e.metadata.period_end}
              </div>
            )}
            {e.note && (
              <div className="text-xs text-slate-600 mt-1 italic">"{e.note}"</div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
